import { UISDK } from "@/ui-sdk";
import { parseHandles } from "../utils";
import { flagCheck } from "..";
import { memoryOperations } from "@/datastore/memory";

export default async function handleInlineBlock(
  element: HTMLElement,
  sdk: UISDK,
) {
  const featureFlags = window.helium.brandData.pro?.featureFlags;
  const val = element.getAttribute("data-helium-inline-block-type");
  const handlesStr = element.getAttribute(
    "data-helium-cart-inline-block-product-handles",
  );
  console.log(val, handlesStr, "featureFlages");
  if (!val) {
    console.log("No valid 'data-helium-inline-block-type-*' attribute found.");
    return;
  }

  if (val === "manual" && !handlesStr) {
    console.log(
      "No valid 'data-helium-cart-inline-block-product-handles' attribute found.",
    );
    return;
  }

  const handles = parseHandles(handlesStr);

  switch (val) {
    case "location":
      if (
        typeof featureFlags?.["because-viewed"] !== "boolean" ||
        !featureFlags?.["because-viewed"]
      )
        break;
      console.log("Performing action for 'location'");
      sdk.renderSimilarInlineBlock(element);
      break;

    case "manual":
      // sdk.renderManualInlineBlock(element, handles);
      break;

    case "faq":
      if (!flagCheck("faqs")) break;
      const id = window.location.pathname.split("/").at(-1) as string;
      const faqs = await window.helium.datastore.getFaq({ id });

      sdk.renderFaq(element, faqs);
      break;

      break;

    default:
      console.log(`Unhandled button attribute value: ${val}`);
      break;
  }
}
